import type { Data } from '@/api/api.ts'
import type { ActDocument, ActsParams, ClosingDocument, ClosingDocumentsParams } from '@/types/docs.types.ts'
import axios from 'axios'
import { baseUrl } from '@/constants/api.ts'

const urlPrefix = `${baseUrl}docs/`

export const getDocsActs = async (params: ActsParams): Promise<Data<ActDocument[]>> =>
  axios.get(`${urlPrefix}calls-contract/`, { params })

export const signActs = async (): Promise<Data<any>> => axios.post(`${urlPrefix}calls-contract/sign/`)

export const getDocsClosingDocuments = async (params: ClosingDocumentsParams): Promise<Data<ClosingDocument[]>> =>
  axios.get(`${urlPrefix}sent-docs/`, { params })
